import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid2,
} from "@mui/material";
import Employeeimg from "../../Assets/Images/employee_img.png";
import Projectimg from "../../Assets/Images/Project_img.png";
import Customerimg from "../../Assets/Images/customer_img.png";
import Mastercard from "../../Component/Mastercards";
import { useNavigate } from "react-router-dom";
import { fetchEmployees } from "../../services/employeeService";

const MasterScreen: React.FC = () => {

  const navigate = useNavigate();
  const [activeEmployeeCount, setActiveEmployeeCount] = useState<number>(0);
  const [lastEmployeeUpdate, setLastEmployeeUpdate] = useState<string>("Loading...");

  useEffect(() => {
    const loadEmployeeStats = async () => {
      try {
        const response = await fetchEmployees(); // fetch returns an object with .data
        const employees = response.data; // ⬅️ extract the actual array here

        // ✅ Count active employees
        const activeCount = employees.filter((e: any) => e.isActive).length;
        setActiveEmployeeCount(activeCount);

        // ✅ Get latest modifiedOn date
        const modifiedDates = employees
          .map((e: any) => new Date(e.modifiedOn))
          .filter((date: Date) => !isNaN(date.getTime()));

        if (modifiedDates.length > 0) {
          const latestModified = modifiedDates.sort((a: Date, b: Date) => b.getTime() - a.getTime())[0];
          const formatted = latestModified.toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          });
          setLastEmployeeUpdate(formatted);
        } else {
          setLastEmployeeUpdate("Unavailable");
        }

      } catch (err) {
        console.error("Failed to fetch employees", err);
        setLastEmployeeUpdate("Unavailable");
      }
    };

    loadEmployeeStats();
  }, []);

  return (
    <Box
      sx={{
        padding: 3,
        backgroundColor: "rgb(238, 242, 246)",
        minHeight: "100vh",
      }}
    >
      <Grid2 container spacing={2} sx={{ height: "100vh" }}>
        <Grid2 size={{ xs: 12, md: 6, lg: 4 }}>
          <Mastercard
            title={"Employees"}
            description={
              "Manage your team: add new employees, edit details, or update records."
            }
            image={Employeeimg}
            primaryColor={"red"}
            stat1={`${activeEmployeeCount} Active Employees`}
            stat2={`Last Update: ${lastEmployeeUpdate}`}
            buttonText={"View Employees"}
            onClick={() => navigate("/EmployeeTable")}
          ></Mastercard>
        </Grid2>

        <Grid2 size={{ xs: 12, md: 6, lg: 4 }}>
          <Mastercard
            title={"Customers"}
            description={
              "Manage your Customer: add new Customer, edit details, or update records."
            }
            image={Customerimg}
            primaryColor={"#D5B251"}
            stat1={"15 Active Projects"}
            stat2={"Last Update: May 20, 2025"}
            buttonText={"View Customers"}
            onClick={() => navigate("/Customers")}
          ></Mastercard>
        </Grid2>

        <Grid2 size={{ xs: 12, md: 6, lg: 4 }}>
          <Mastercard
            title={"Projects"}
            description={
              "Manage your Projects: add new Projects, edit details, or update records."
            }
            image={Projectimg}
            primaryColor={"#66BAFF"}
            stat1={"15 Active Projects"}
            stat2={"Last Update: May 20, 2025"}
            buttonText={"View Projects"}
            onClick={() => navigate("/Projects")}
          ></Mastercard>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default MasterScreen;
